module.exports = __webpack_public_path__ + "img/logo-title.760d7bb9.webp";